import React, {useEffect, useRef, useState} from 'react'
import Step2 from './steps/Step2'
import Step1 from './steps/Step1'
import Step3 from './steps/Step3'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'

const Wizard = () => {
  const dispatch = useDispatch()
  const [activeStep, setActiveStep] = useState(1)

  useEffect(() => {
    dispatch(setTitle('Settings'))
  }, [dispatch])

  const handleStepChange = (stepIndex) => {
    setActiveStep(stepIndex)
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div
          className='stepper stepper-links d-flex flex-column pt-15'
          id='kt_create_account_stepper'
        >
          {/* Step Navigation */}
          <div className='stepper-nav mb-5 gap-10'>
            <div
              className={`stepper-item ${activeStep === 1 ? 'current' : ''}`}
              onClick={() => handleStepChange(1)}
              style={{cursor: 'pointer'}}
            >
              <h3 className='stepper-title'>General Settings</h3>
            </div>
            <div
              className={`stepper-item ${activeStep === 2 ? 'current' : ''}`}
              onClick={() => handleStepChange(2)}
              style={{cursor: 'pointer'}}
            >
              <h3 className='stepper-title'>Benefits</h3>
            </div>
            <div
              className={`stepper-item ${activeStep === 3 ? 'current' : ''}`}
              onClick={() => handleStepChange(3)}
              style={{cursor: 'pointer'}}
            >
              <h3 className='stepper-title'>Mail Configuration</h3>
            </div>
          </div>

          {/* Step Content */}
          <div className='stepper-content'>
            {activeStep === 1 && (
              <div className='stepper-pane active'>
                <Step1 />
              </div>
            )}
            {activeStep === 2 && (
              <div className='stepper-pane active'>
                <Step2 />
              </div>
            )}
            {activeStep === 3 && (
              <div className='stepper-pane active'>
                <Step3 />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export {Wizard}
